module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/website-109b1c2742d8524ed123d0547c10dab1.svg";